module.exports = __webpack_public_path__ + "img/eswop@2x.6d7a3e20.png";